import { Authority } from '@/shared/security/authority';

const Register = () => import('@/account/register/register.vue');
const Activate = () => import('@/account/activate/activate.vue');
const ResetPasswordInit = () => import('@/account/reset-password/init/reset-password-init.vue');
const ResetPasswordFinish = () => import('@/account/reset-password/finish/reset-password-finish.vue');
const ChangePassword = () => import('@/account/change-password/change-password.vue');
const Settings = () => import('@/account/settings/settings.vue');

let p = sessionStorage.getItem('baseUrl') ? sessionStorage.getItem('baseUrl') : '/';
if (p != '/') {
  p += '/';
}
export default [
  {
    path: p + 'register',
    name: 'Register',
    component: Register,
  },
  {
    path: p + 'account/activate',
    name: 'Activate',
    component: Activate,
  },
  {
    path: p + 'account/reset/request',
    name: 'ResetPasswordInit',
    component: ResetPasswordInit,
  },
  {
    path: p + 'account/reset/finish',
    name: 'ResetPasswordFinish',
    component: ResetPasswordFinish,
  },
  {
    path: p + 'account/password',
    name: 'ChangePassword',
    component: ChangePassword,
    // meta: { authorities: [Authority.USER,Authority.COMPANY_ADMIN] },
  },
  {
    path: p + 'account/settings',
    name: 'Settings',
    component: Settings,
    // meta: { authorities: [Authority.USER,Authority.COMPANY_ADMIN] },
  },
];
